export default __webpack_public_path__ + "static/media/SLIDER-Vikkymore-Agromart.eb108d2d.png";